
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/participation/participants",
      function () {
        return require("private-next-pages/participation/participants.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/participation/participants"])
      });
    }
  